



































































import { Component, Vue } from "vue-property-decorator";
import { EditClientFormCpt } from "./components";
import { WorkshopModel, CompanyModel } from "@/core/models";
import { WorkshopService, CompanyService } from "@/core/services";
import {
  ClientDetailHeaderCpt,
  WorkshopDetailHeaderCpt,
  EditAttendeeFormCpt,
  TransferCompanyWorkshopDialogCpt,
} from "./components";

import AppVue from "@/AppVue.vue";

@Component({
  components: {
    WorkshopDetailHeaderCpt,
    EditClientFormCpt,
    ClientDetailHeaderCpt,
    EditAttendeeFormCpt,
    TransferCompanyWorkshopDialogCpt,
  },
})
export default class WorkshopEditClient extends AppVue {
  companyModel?: CompanyModel = new CompanyModel();

  get workshopId() {
    return Number(this.$route.params.workshopId);
  }
  get companyId() {
    return Number(this.$route.params.companyId);
  }

  model = {} as WorkshopModel;
  loading = false;
  showTransferCompanyDialog = false;

  async created() {
    this.initializeModel();
  }

  private transferCompany() {
    this.showTransferCompanyDialog = true;
  }

  private closeTransferCompany(workshopId: number) {
    this.showTransferCompanyDialog = false;
    if (workshopId) {
      this.$router.push(`/admin/workshops/${workshopId}/client/${this.companyId}/edit`);
      this.initializeModel();
    }
  }

  private async initializeModel() {
    this.loading = true;
    try {
      this.model = await WorkshopService.getWorkshop(this.workshopId);
      this.companyModel = this.model.companies.find(x => x.id === this.companyId);
    } finally {
      this.loading = false;
    }
  }
}
